import React from 'react';
import LogTable from 'components/atoms/log-table';
import { useRpmClaimStatusLog } from 'infrastructure/hooks/logs/use-rpm-claim-status-log';
import useUpdateEffect from 'infrastructure/hooks/utils/use-update-effect';

interface IPatientRpmClaimStatusLogProps {
  patientGuid: string;
  dateRange?: [Date, Date];
}

const PatientRpmClaimStatusLog: React.FC<IPatientRpmClaimStatusLogProps> = (
  props,
) => {
  const { patientGuid, dateRange } = props;

  const { loading, items, meta, setMeta } = useRpmClaimStatusLog({
    patientGuid,
    meta: {
      dateRange,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
      dateRange,
    });
  };

  useUpdateEffect(() => {
    setMeta({
      ...meta,
      page: 1,
      dateRange,
    });
  }, [dateRange]);

  return (
    <LogTable
      dataCy="patient-rpm-сlaim-status-log-table"
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomRight'],
      }}
      onChangePage={onChangePage}
    />
  );
};

export default PatientRpmClaimStatusLog;
